export const CONFIG = {
  orientation: "portrait",
  unit: "pt",
  format: "letter",
}
